import { GET_SECTION_SUCCESS, GET_SECTIONS_SUCCESS } from '../actions/sectionsActionTypes';

// const initialState = {
//   1: {
//     id: 1,
//     title: 'Nursing',
//     questions: {
//       1: {
//         "id": 1,
//         "index": 0,
//         "prompt_id": null,
//         "section_id": 1,
//         "content": "DOPAMINE INFUSION",
//         "label": null,
//         "instructions": "Review the orderable options for the following injectable medications in the CPOE. What are the standard doses and concentrations of injectable medications defined by the hospital? To what extent does the system allow for the creation of nonstandard doses and concentrations? Is there an opportunity to further streamline standardized doses and concentrations?",
//         "questionType": "multipart",
//         "parts": [
//           {
//             "id": 2,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Dose(s)",
//             "instructions": null,
//             "questionType": "short_answer"
//           },
//           {
//             "id": 3,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Concentration(s)",
//             "instructions": null,
//             "questionType": "short_answer"
//           },
//           {
//             "id": 4,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Route(s) of administration",
//             "instructions": null,
//             "questionType": "short_answer"
//           },
//           {
//             "id": 5,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Diluent(s)",
//             "instructions": null,
//             "questionType": "short_answer"
//           },
//           {
//             "id": 6,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Rates of administration",
//             "instructions": null,
//             "questionType": "short_answer"
//           },
//           {
//             "id": 7,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Special instructions",
//             "instructions": null,
//             "questionType": "long_answer"
//           },
//           {
//             "id": 8,
//             "prompt_id": 1,
//             "section_id": null,
//             "content": null,
//             "label": "Are nonstandard elements able to be ordered (e.g. nonstandard doses and concentrations)?",
//             "instructions": null,
//             "questionType": "radio",
//             "parts": [{
//               id: 12,
//               label: 'Frequently'
//             }, {
//               id: 13,
//               label: 'Somewhat frequently'
//             }, {
//               id: 14,
//               label: 'Uncommon'
//             }]
//           }
//         ]
//       },
//       6: {
//         id: 6,
//         index: 4,
//         content: 'Please rank your preference for how the pharmacy should provide routine, scheduled medications based on orders for injectable medications (not urgent or emergent orders):\n\nPurchasing when available, manufacturer-prepared premixed IV solutions.',
//         questionType: 'slider',
//         parts: [
//           {
//             "id": 10,
//             "prompt_id": 6,
//             "section_id": null,
//             "content": null,
//             "label": "On a scale of 1–10 (1 being strongly disagree, 10 being strongly agree)",
//             "instructions": null
//           }
//         ]
//       },
//       2: {
//         id: 2,
//         index: 5,
//         content: 'What do you use to dilute prefilled syringes?\n(e.g. vials of saline, prefilled saline syringes, etc.)',
//         questionType: 'long_answer',
//         parts: [
//           {
//             "id": 11
//           }
//         ]
//       },
//       3: {
//         id: 3,
//         index: 3,
//         content: 'Do you make PCA admixtures or syringes?',
//         questionType: 'radio',
//         parts: [{
//           id: 12,
//           label: 'Frequently'
//         }, {
//           id: 13,
//           label: 'Somewhat frequently'
//         }, {
//           id: 14,
//           label: 'Uncommon'
//         }]
//       },
//       5: {
//         id: 5,
//         index: 1,
//         content: 'Which of these manufacturer-prepared (not compounding facility) prefilled medication syringes are purchased?',
//         questionType: 'checkbox',
//         parts: [{
//           id: 15,
//           label: 'Midazolam IV Injection'
//         }, {
//           id: 16,
//           label: 'Fentanyl IV Injection'
//         }, {
//           id: 17,
//           label: 'Dexamethasone IV Injection'
//         }]
//       },
//       7: {
//         id: 7,
//         index: 2,
//         content: 'Please rank your preferred order for providing injectable medications:',
//         questionType: 'ranking',
//         parts: [{
//           id: 18,
//           label: 'Purchasing manufacturer-prepared IV solutions and prefilled syringes'
//         }, {
//           id: 19,
//           label: 'Purchasing IV solutions and prefilled syringes from 503B compounding facilities'
//         }, {
//           id: 20,
//           label: 'IV solutions and prefilled syringes prepared by hospital pharmacy'
//         }, {
//           id: 21,
//           label: 'IV solutions and prefilled syringes prepared by nurses'
//         }]
//       }
//     }
//   },
//   2: {
//     title: "Pharmacy"
//   },
//   3: {
//     title: "Anesthesia"
//   },
//   4: {
//     title: "Patient Care"
//   }
// };

export default function sections(state = {}, action) {
  switch (action.type) {
    case GET_SECTION_SUCCESS:
      // overwrite the corresponding shallow section
      return {
        ...state,
        ...action.section,
      };
    case GET_SECTIONS_SUCCESS: {
      // leave any deep sections but overwrite shallow or undefined ones
      const newObj = { ...state };
      Object.keys(action.sections).forEach((key) => {
        if (!newObj[key] || !newObj[key].questions) newObj[key] = action.sections[key];
      });
      return newObj;
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/sectionsReducer.js